export default "__VITE_ASSET__qVIyW0dt__"